// usage like: 
// >> import vehicles from "@/vehicles";
// >> vehicles.img("Sii Lors");
// returns: "/img/vehicles/name.png"
// used in fleet workflow json settings like icon: "Taxi" (case sensitive)

// ** Also need to add any new icon Names to backend code **
// endpoints/workflows.go
// func checkFleetIcon
// array: validIconNames

// key = human readable name, value = file_name[.png]
const images = {
    "Sii Lor": "siilor_new", //"siilor",
    "Songthaew": "songthaew_new",
    "Taxi": "taxi",
    "VIP Taxi": "vip_taxi",
    "Van": "van",
    "Toto": "toto",
    "Horse Cart": "horse",
    "Balloon": "balloon",
    "Motorbike": "motorbike_new", // was: moto
    "Private Building": "private_bldg",
    "Private Tuk Tuk": "private_tuktuk_new", // was: "private_tuktuk",
    "Tuk Tuk": "tuktuk",
    "Tourist Tuk Tuk": "tourist_tuktuk_new",
    // "Public Tuk Tuk": "tourist_tuktuk_new",
    "Refrigerated": "refrigerated",
    "Container": "container",
    "Flatbed": "flatbed",
    "10 Wheeler": "10wheeler",
    "6 Wheeler": "6wheeler",
    "Cleaner": "cleaner",
    "Pizzamania": "pizzamania"
}

var vehicles = {
    img(name) {
        // first check aliases
        if (name === "Private") name = "Private Tuk Tuk"
        if (name === "Tuk Tuk") name = "Private Tuk Tuk"
        if (name === "Public Tuk Tuk") name = "Tourist Tuk Tuk"
        if (name === "Car") name = "VIP Taxi"
        if (name === "Private Car") name = "VIP Taxi"
        var img = images[name]
        if (img) return `/img/vehicles/${img}.png`
        return "/img/vehicles/driver.svg" // else return default, changed from attention.svg
    }

}

export default vehicles

// Sii Lor
// Songthaew
// Taxi
// VIP Taxi
// Van
// Toto
// Horse Cart
// Balloon
// Motorbike
// Private Building
// Private Tuk Tuk
// Tuk Tuk
// Tourist Tuk Tuk